"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fromQueryString = _interopRequireDefault(require("./from-query-string"));

var _toQueryString = _interopRequireDefault(require("./to-query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function replaceQueryParameters(url, query) {
  var urlFragments = url.split('?');
  var baseUrl = urlFragments[0];
  var originalQueryString = urlFragments[1];
  var originalQuery = (0, _fromQueryString["default"])(originalQueryString);
  var newQuery = Object.assign({}, originalQuery, query);
  return "".concat(baseUrl).concat((0, _toQueryString["default"])(newQuery));
}

var _default = replaceQueryParameters;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@creuna/utils/replace-query-parameters.js
// module id = 214
// module chunks = 0